import React, {useEffect, useState} from 'react'
import BreadCrumb from '../../ass_components/BreadCrumb'
import { useSelector } from 'react-redux';
import Meta from '../../ass_components/Meta'
import ReactMarkdown from "react-markdown";
import { translate } from '../../i18n';
import { FaSeedling, FaChartLine, FaShoppingCart } from "react-icons/fa";


const GettingStarted = () => {
    // Language setup
    const language_code = useSelector((state) => state.lang)
    const [gettingStartedText, setGettingStartedText] = useState('');

    useEffect(() => {

        const filePath = language_code.lang === 'FR'
            ? './text-contents/footer-texts/policies/getting-started/getting-started-fr.md'
            : './text-contents/footer-texts/policies/getting-started/getting-started-en.md';

        fetch(filePath)
            .then((response) => {

                if (!response.ok) {
                    throw new Error('Failed to load policy text');
                }
                return response.text();
            })
            .then((text) => setGettingStartedText(text))
            .catch((error) => {
                console.error('Error loading policy text:', error);
                setGettingStartedText('Erreur de chargement de la politique.');
            });
    }, [language_code]);

    const videoUrl =
        language_code.lang === 'FR'
            ? 'https://www.youtube.com/embed/7yD85vSwGno'
            : 'https://www.youtube.com/embed/-bRgHRootcg';

    return (
        <>
            <Meta title={"Details"}/>
            <BreadCrumb title="Contenu d'article"/>
            <div className='wishlist-wrapper assiganto-home-wrapper-2 py-5'>
                <div className='container-xxl'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='policy'>
                                <div className="policy-markdown-container">
                                    <div className='login-picto'>
                                        <img src='images/core_images/assiganto-picto.png'
                                             className='img-fluid'
                                             alt='small-banner'
                                             onContextMenu={(e) => e.preventDefault()} // prevent right-click
                                             draggable="false" // prevent drag
                                             style={{ userSelect: 'none', pointerEvents: 'auto' }}
                                        />
                                    </div>
                                    <div className="policy-markdown">
                                        <center><h5>{translate('footer', language_code.lang).content_labels.content_label_11}</h5></center>
                                        <ReactMarkdown>{gettingStartedText}</ReactMarkdown>
                                    </div>
                                </div>
                                {/* ▶️ Embedded YouTube Video */}
                                <div className="row text-center mb-4">
                                    <div className="col-md-4">
                                        <FaSeedling size={28} className="text-success mb-2" />
                                        <p>Gérez vos parcelles</p>
                                    </div>
                                    <div className="col-md-4">
                                        <FaChartLine size={28} className="text-primary mb-2" />
                                        <p>Optimisez vos rendements</p>
                                    </div>
                                    <div className="col-md-4">
                                        <FaShoppingCart size={28} className="text-warning mb-2" />
                                        <p>Vendez vos récoltes</p>
                                    </div>
                                </div>

                                <p className="text-center text-muted mb-4">
                                    {language_code.lang === 'FR'
                                        ? "Cette vidéo vous guide pas à pas dans la prise en main d’ASSIGANTO AGRO."
                                        : "This video walks you through the first steps of using ASSIGANTO AGRO."}
                                </p>

                                <div className="ass-video-section mt-5">
                                    <h5 className="text-center mb-3">
                                        {language_code.lang === 'FR'
                                            ? 'Vidéo explicative'
                                            : 'Introductory Video'}
                                    </h5>

                                    <div className="ass-video-wrapper">
                                        <iframe
                                            src={videoUrl}
                                            title="Assiganto video"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        />
                                    </div>
                                </div>
                                <div className="text-center mt-4">
                                    <a href="/signup" className="btn btn-success px-4 py-2">
                                        {language_code.lang === 'FR'
                                            ? "Commencer maintenant"
                                            : "Get Started"}
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default GettingStarted